import { useQuery } from '@tanstack/react-query';

import { getViews } from '@/domains/access/systemConfigApi';
import type { ViewSetting } from '@/domains/access/access.types';

/**
 * Fetches the configured evaluation views (name + required role) from the
 * backend. Shares the `['system', 'views']` query key with the Views Manager
 * tab, so creating/editing a view there refreshes the evaluation switcher too.
 */
export const useEvaluationViews = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['system', 'views'],
    queryFn: async () => (await getViews()).data,
    staleTime: 60 * 60 * 1000,
  });

  const views: ViewSetting[] = data ?? [];
  return { views, isViewsLoading: isLoading };
};
